import { defineStore } from 'pinia';
import { RouteRecordRaw } from 'vue-router';

import { allRoutes } from '@/router';
import { store } from '@/store';

const getRoutePermission = (route: RouteRecordRaw) => route.meta?.permission || route.meta?.roleCode;

function hasRoutePermission(route: RouteRecordRaw, permissions: Array<unknown>) {
  const code = getRoutePermission(route);
  if (!code) return true;
  return permissions.includes('all') || permissions.includes(code);
}

function filterPermissionsRouters(routes: Array<RouteRecordRaw>, permissions: Array<unknown>) {
  const res: Array<RouteRecordRaw> = [];
  const removeRoutes: Array<RouteRecordRaw> = [];
  routes.forEach((route) => {
    const routeRecord = { ...route };
    if (route.children?.length) {
      const childResult = filterPermissionsRouters(route.children, permissions);
      routeRecord.children = childResult.accessedRouters;
      removeRoutes.push(...childResult.removeRoutes);
    }

    if (hasRoutePermission(route, permissions) || routeRecord.children?.length) {
      res.push(routeRecord);
    } else {
      removeRoutes.push(route);
    }
  });
  return { accessedRouters: res, removeRoutes };
}

export const usePermissionStore = defineStore('permission', {
  state: () => ({
    whiteListRouters: ['/login', '/index'],
    routers: [],
    removeRoutes: [],
    initialized: false,
  }),
  actions: {
    async initRoutes(permissions: Array<unknown> = []) {
      let accessedRouters = [];

      let removeRoutes: Array<RouteRecordRaw> = [];
      // special token
      if (permissions.includes('all')) {
        accessedRouters = allRoutes;
      } else {
        const res = filterPermissionsRouters(allRoutes, permissions);
        accessedRouters = res.accessedRouters;
        removeRoutes = res.removeRoutes;
      }

      this.routers = accessedRouters;
      this.removeRoutes = removeRoutes;
      this.initialized = true;
    },
    async restore() {
      this.routers = [];
      this.removeRoutes = [];
      this.initialized = false;
    },
  },
});

export function getPermissionStore() {
  return usePermissionStore(store);
}
